import React, { FC, ReactNode } from 'react';
import { Box, Drawer as MuiDrawer, Theme, styled } from '@material-ui/core';

import { SidebarButton } from './SidebarButton';
import { SidebarDivider } from './SidebarDivider';
import { Icons } from '../SvgIcon';
import { ITrajectoryDetail } from '../../../../config/api/models/Trajectory';
import { Button } from '../buttons';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../hooks';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  open: boolean;
  onClose: () => void;
  onPublish: () => void;
  onUnPublish: () => void;
  header?: ReactNode;
  trajectory?: ITrajectoryDetail;
};

const Drawer = styled(MuiDrawer)({
  '& .MuiDrawer-paper': {
    width: '60rem',
    overflow: 'visible',
    maxWidth: '90vw',
  },
});

const DrawerHeaderWrapper = styled(Box)<Theme>(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(3),
}));

export const DrawerContentWrapper = styled(Box)<Theme>(({ theme }) => ({
  padding: theme.spacing(0, 3, 1),
  overflowY: 'auto',
}));

export const DrawerEdgeWrapper = styled(Box)<Theme>(({ theme }) => ({
  position: 'absolute',
  top: '2.5rem',
  left: 0,
  transform: 'translateX(-50%)',
  zIndex: 999,
  padding: theme.spacing(0, 3),
}));

const ButtonWrapper = styled('div')({
  position: 'absolute',
  top: '50%',
  right: '2rem',
  transform: 'translateY(-50%)',
});

export const SidebarDrawer: FC<Props> = ({
  open,
  onClose,
  onPublish,
  onUnPublish,
  header,
  trajectory,
  children,
}) => {
  const { t } = useTranslation();
  const { isAuthor } = useUser();

  return (
    <Drawer disablePortal open={open} onClose={onClose} anchor="right">
      <DrawerEdgeWrapper>
        <SidebarButton variant="filled" onClick={onClose}>
          <FontAwesomeSpriteIcon
            icon={SpriteIconsLight.ANGLE_RIGHT}
            iconSize="lg"
            color="inherit"
          />
        </SidebarButton>
      </DrawerEdgeWrapper>

      {header && (
        <>
          <DrawerHeaderWrapper>
            {header}
            {!!trajectory && isAuthor && (
              <ButtonWrapper>
                {trajectory.isDraft ? (
                  <Button icon={Icons.PUBLISH_DRAFT} onClick={onPublish}>
                    {t('books.chapter.trajectories.publish')}
                  </Button>
                ) : (
                  <Button icon={Icons.UN_PUBLISH_DRAFT} onClick={onUnPublish}>
                    {t('books.chapter.trajectories.unPublish')}
                  </Button>
                )}
              </ButtonWrapper>
            )}
          </DrawerHeaderWrapper>
          <SidebarDivider />
        </>
      )}

      <DrawerContentWrapper>{children}</DrawerContentWrapper>
    </Drawer>
  );
};
